import type { Dict } from "../core.js";
import type { bankTransfer as vi } from "../vi/bankTransfer.js";

export const bankTransfer: Dict<typeof vi> = {
  title: "Confirm bank transfer",
  "intro.pre": "Use this when money arrives in Bube's account. The transfer description ",
  "intro.strong1": "is",
  "intro.mid": " the payment code. Confirming activates the store's plan and issues an e-invoice — ",
  "intro.strong2": "this cannot be undone",
  "intro.post": ".",
  codeLabel: "Payment code",
  codePlaceholder: "e.g. Ab3xK9mQ2p",
  lookingUp: "Looking up…",
  lookup: "Look up",
  lookupFailed: "Couldn't look up this payment code.",
  confirmFailed: "Couldn't confirm.",
  "result.confirmed": "Confirmed. The plan has been applied.",
  "result.confirmedWithLots": "Confirmed. The plan has been applied, and {count} extra lot(s) were activated.",
  "result.alreadyConfirmed": "This payment was already confirmed — this click granted nothing extra, as expected.",
  "result.shortfall": " Recorded an UNDERPAYMENT of {amount}.",
  "result.overpaid": " Customer OVERPAID by {amount}.",
  workspace: "Store",
  workspaceDeleted: "(workspace deleted)",
  plan: "Plan",
  months: "{months} months",
  amountDue: "Amount due",
  period: "Period",
  "already.pre": "This payment ",
  "already.strong": "has already been confirmed",
  "already.post": ". Nothing more to do.",
  "paypal.pre": "This payment was made via ",
  "paypal.post":
    ", not a bank transfer. That flow confirms itself on capture — confirming manually here would grant the plan without collecting payment.",
  paidLabel: "Amount ACTUALLY received (from the bank statement)",
  "short.pre": "The customer ",
  "short.strong": "underpaid by {amount}",
  "short.post": ". I understand and still want to grant the plan. The shortfall is recorded in bube-shop.",
  overpaid: "The customer overpaid by {amount} — you can still confirm.",
  confirming: "Confirming…",
  confirm: "Confirm payment received",
  tickShortfall: "Tick the underpayment box to enable the button.",
};
